import config from './config.js'

export default {

    list(start,count) {
        var url = config.baseUrl + "rest/datagraph/configs?start=" + encodeURIComponent(start) + '&count=' + encodeURIComponent(count);
        return fetch(url, {
            credentials: 'include'
        }).then(resp => resp.json());
    },

    save(graph) {
        var url = config.baseUrl + "rest/datagraph/configs";
        return fetch(url, {
            credentials: 'include',
            method: "POST",
            body: JSON.stringify(graph)
        }).then(resp => resp.json());
    },

    load(id) {
        var url = config.baseUrl + "rest/datagraph/configs/" + encodeURIComponent(id);
        return fetch(url, {
            credentials: 'include'
        }).then(resp => resp.json());
    },

    synchronize(id,reindex) {
        var url = config.baseUrl + "rest/datagraph/synchronize/" + encodeURIComponent(id) + '?reindex=' + encodeURIComponent(reindex);
        return fetch(url, {
            credentials: 'include'
        }).then(resp => resp.json());
    }

}